<template>
    <v-list :class="downClass">
        <v-list-item v-bind="attr" v-on="on" link>
            <v-list-item-content>
                <v-list-item-title class="text-h6">
                    {{ GET_USER_NAME }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ GET_USER_EMAIL }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ GET_USER_ROLE }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
                :class="downClass"
            >
                <svg-icon type="mdi" :path="$data.icons.menu" />
            </v-list-item-action>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import SvgIcon from "@jamescoyle/vue-icon";
import {mdiMenuDown} from "@mdi/js";


export default {
    name: "UserPreviewPart",
    components: {SvgIcon},
    props: ['attr', 'on', 'downClass'],
    data: () => ({
        icons: {
            menu: mdiMenuDown,
        },
    }),
    computed: {
        ...mapGetters(['GET_USER_NAME', 'GET_USER_EMAIL', 'GET_USER_ROLE'])
    }
}
</script>

<style scoped>
.v-list-item__content {
    padding: 5px 0 0 0!important;
}
</style>
